(function () {
  'use strict';

  angular
    .module('component.addtowishlist', [])

    .component('buttonAddToWishlist', {
      bindings: {
        isProductButton: '<?',
        id: '<idProduct',
        isPrimary: '<',
        url: '@productUrl',
        titleAdd: '@',
        titleRemove: '@',
        tooltipAdd: '@',
        tooltipYet: '@',
        tooltipChoice: '@?',
        message: '@',
        device: '<'
      },
      templateUrl: 'component.addtowishlist.tpl',
      /* @ngInject */
      controller: ["$scope", "LoadService", function ($scope, LoadService) {
        var ctrl = this;

        ctrl.$onInit = function () {
          ctrl.js = $(document.body).data('js-wishlist-components');
          LoadService.getService('AsyncWishlistComponentsService', { ctrl: ctrl, scope: $scope }, 'initWishlist');
        };
      }]
    });

})();
